import React, { ReactNode } from 'react';

interface DashboardGridItemProps {
  children: ReactNode;
  colSpan?: {
    default?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
  rowSpan?: {
    default?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
  className?: string;
}

const DashboardGridItem: React.FC<DashboardGridItemProps> = ({
  children,
  colSpan,
  rowSpan,
  className = ''
}) => {
  const getSpanClasses = () => {
    const classes = [];
    
    // Column span
    if (colSpan) {
      if (colSpan.default) {
        classes.push(`col-span-${colSpan.default}`);
      }
      if (colSpan.sm) {
        classes.push(`sm:col-span-${colSpan.sm}`);
      }
      if (colSpan.md) {
        classes.push(`md:col-span-${colSpan.md}`);
      }
      if (colSpan.lg) {
        classes.push(`lg:col-span-${colSpan.lg}`);
      }
      if (colSpan.xl) {
        classes.push(`xl:col-span-${colSpan.xl}`);
      }
    }
    
    // Row span
    if (rowSpan) {
      if (rowSpan.default) {
        classes.push(`row-span-${rowSpan.default}`);
      }
      if (rowSpan.sm) {
        classes.push(`sm:row-span-${rowSpan.sm}`);
      }
      if (rowSpan.md) {
        classes.push(`md:row-span-${rowSpan.md}`);
      }
      if (rowSpan.lg) {
        classes.push(`lg:row-span-${rowSpan.lg}`);
      }
      if (rowSpan.xl) {
        classes.push(`xl:row-span-${rowSpan.xl}`);
      }
    }
    
    return classes.join(' ');
  };

  return (
    <div className={`${getSpanClasses()} ${className}`}>
      {children}
    </div>
  );
};

export default DashboardGridItem;